import {
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '@/common/api/api.service'
import { API_BASE_URL_ACCOUNT, HTTP_METHOD_DELETE } from '@/common/constant'

/**
 * 디바이스 관리 - 선택한 디바이스 로그아웃
 */
export const deleteDevice = async ({ id }) => {
  try {
    if (!id) {
      return { error: 'id is required' }
    }
    const url = `${API_BASE_URL_ACCOUNT}/v1/devices/${id}/tokens`
    const response = await apiRequest(
      commonRequestInstanceToAxiosRequestInfo({
        url,
        method: HTTP_METHOD_DELETE,
        needCommonParams: true,
        needCredential: true,
      }),
    )
    if (!response) return { data: undefined }
    return response
  } catch (error) {
    return {
      error: error.message,
    }
  }
}
